import { Button } from "@/components/ui/button";

type SingleErrorProps = {
  error: string;
  nextAction?: () => void;
  nextActionText?: string;
};

// Uses colors from :root and .dark { ... } in styles.css (e.g. bg-destructive, bg-card, etc)
export function SingleError({ error, nextAction, nextActionText = "OK" }: SingleErrorProps) {
  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center select-none bg-gradient-to-br from-destructive/90 via-background/90 to-foreground/50 dark:from-destructive/85 dark:via-background/80 dark:to-foreground/30">
      <div className="rounded-2xl shadow-2xl bg-card/95 border-2 border-destructive flex flex-col px-10 py-12 min-w-[360px] max-w-md items-center">
        <div className="flex items-center gap-3 mb-6">
          <svg
            viewBox="0 0 24 24"
            className="w-10 h-10 text-destructive shrink-0"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
          >
            <circle cx="12" cy="12" r="10" className="fill-destructive/10 stroke-destructive" />
            <path
              d="M12 7v5m0 4h.01"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-2xl sm:text-3xl font-extrabold text-destructive tracking-tight font-display">
            Error
          </span>
        </div>
        <h2 className="text-center text-xl sm:text-2xl font-semibold text-foreground mb-4 font-display">
          Something went wrong
        </h2>
        <div className="text-center text-lg sm:text-xl text-destructive font-medium mb-6 px-2 break-words font-body">
          {error}
        </div>
        {nextAction && (
          <div className="mt-2 w-full flex justify-center">
            <Button
              variant="outline"
              className="text-base font-semibold border-destructive text-destructive hover:bg-destructive/10 hover:border-destructive"
              onClick={nextAction}
              autoFocus
            >
              {nextActionText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

